<template>
  <!-- 首页-商标检索部分 -->
  <div>
    <div class="search-commonbox search-brandbox">
      <el-radio-group class="common-radiobox brand-radiobox" v-model="brandRadio" @change="brandSelectChange">
        <el-radio-button data-num="1" label="ti">近似查询</el-radio-button>
        <el-radio-button data-num="2" label="an">商标号</el-radio-button>
        <el-radio-button data-num="3" label="ap">申请人</el-radio-button>
        <el-radio-button data-num="4" label="apad">申请人地址</el-radio-button>
        <el-radio-button data-num="5" label="ac">代理机构</el-radio-button>
        <el-radio-button data-num="6" label="rn">公告期号</el-radio-button>
      </el-radio-group>
      <div class="common-querybox brand-querybox">
        <div class="comquery-inputbox">
          <!-- <el-input
            class="inputbox-input"
            v-if="brandRadio == 'apad'"
            readonly
            v-model="brandQueryValue"
            :placeholder="brandPlaceholder"
            @keyup.enter.native="isLogin(1)"
          ></el-input> -->
          <el-input
            class="inputbox-input"
            v-model="brandQueryValue"
            :placeholder="brandPlaceholder"
            @keyup.enter.native="isLogin(1)"
          ></el-input>
          <el-button class="inputbox-btn" @click="isLogin(1)">搜索</el-button>
        </div>
        <span class="comquery-advanced" @click="isLogin(2)">高级搜索</span>
      </div>
      <div class="common-comcheckbox">
        <el-checkbox-group class="comcheckbox-group" v-model="brandCheckTsList" @change="brandTsChange">
          <el-checkbox label="申请中">申请中</el-checkbox>
          <el-checkbox label="已注册">已注册</el-checkbox>
          <el-checkbox label="已无效">已无效</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="common-inforcon">
        <p class="inforcon-inforp">数据覆盖：中国大陆地区的 {{ tradeResult.count | num }} 项商标</p>
        <p class="inforcon-inforp">最近更新：{{ tradeResult.date | time }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import citysData from '@/assets/js/region.js'
export default {
  data() {
    return {
      brandInputPH: [
        // 商标检索-根据不同的选项input输入框展示不同的placeholder提示
        { name: 'ti', value: '检索商标名称，快速生成查询分析报告' },
        { name: 'an', value: '请输入商标号' },
        { name: 'ap', value: '请输入申请人名称' },
        { name: 'apad', value: '请输入申请人地址' },
        { name: 'ac', value: '请输入代理机构名称' },
        { name: 'rn', value: '请输入公告期号（最新期号： 1651）' }
      ],
      brandRadio: 'ti', // 商标检索-单选
      brandQueryValue: '', // 商标检索-input输入内容-检索条件
      brandPlaceholder: '检索商标名称，快速生成查询分析报告',
      brandCheckTsList: ['申请中', '已注册', '已无效'],
      brandCheckTsVal: '', // 商标检索-复选框选中-条件
      // addressOptions: citysData, // 商标检索-地区选择器
      // provinceName: '北京', // 商标检索-获取选择的省份'河北'、'北京'
      // cityName: '东城区', // 商标检索-获取选择的城市'石家庄市'、'海淀区'
      // prefectureName: '', // 商标检索-获取选择的下级县'长安区'、''
      // addressValue: '', //  商标检索-获取输入的详细地址
      // cityDatas: [], // 商标检索-获取城市列表
      // prefectureDatas: [], // 商标检索-获取下级县列表
      tradeResult: {} // 数量和更新时间
    }
  },
  filters: {
    time(val) {
      if (!val) return ''
      val = val.toString()
      return val.substring(0, 4) + '/' + val.substring(4, 6) + '/' + val.substring(6, 8)
    },
    num(val) {
      if (!val) return '0'
      val = val.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      return val
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    // 商标检索-单选
    brandSelectChange: function () {
      let _this = this
      console.log(_this.brandRadio)
      // _this.brandQueryValue = ''
      for (let i in _this.brandInputPH) {
        if (_this.brandRadio == _this.brandInputPH[i].name) {
          _this.brandPlaceholder = _this.brandInputPH[i].value
        }
      }
    },
    getInfo() {
      this.$axios({
        method: 'get',
        url: '/trademarkService/trademark/updateInfo'
      }).then((res) => {
        this.tradeResult = res.data
        // console.log(res)
      })
    },
    // 商标检索-申请中/注册/失效-复选框
    brandTsChange: function () {
      let _this = this
      console.log(_this.brandCheckTsList)
    },

    // 商标检索-点击搜索
    brandSearchHandle: function () {
      let _this = this
      _this.brandCheckTsVal = ''
      if (_this.brandCheckTsList.length > 0 && _this.brandCheckTsList.length < 3) {
        _this.brandCheckTsVal = '('
        for (let i = 0; i < _this.brandCheckTsList.length; i++) {
          if (i == _this.brandCheckTsList.length - 1) {
            _this.brandCheckTsVal += 'ts=(' + _this.brandCheckTsList[i] + '))'
          } else {
            _this.brandCheckTsVal += 'ts=(' + _this.brandCheckTsList[i] + ') or '
          }
        }
      }
      console.log('商标检索条件--' + _this.brandCheckTsVal)
      // 输入框检索条件
      let inputVal = ''
      if (_this.brandRadio != 'rn') {
        if (_this.brandQueryValue) {
          inputVal =
            (_this.brandCheckTsVal ? _this.brandCheckTsVal + ' and ' : '') +
            _this.brandRadio +
            '=(' +
            _this.brandQueryValue +
            ')'
        }
      } else {
        if (_this.brandQueryValue) {
          inputVal =
            (_this.brandCheckTsVal ? _this.brandCheckTsVal + ' and ' : '') +
            'pen=(' +
            _this.brandQueryValue +
            ') or rn=(' +
            _this.brandQueryValue +
            ')'
        }
      }

      console.log(inputVal)
      // 跳转页面
      // let { href } = this.$router.resolve({
      //   path: '/brand/search',
      //   query: { inputVal: inputVal }
      // })
      // window.open(href, '_blank') // 跳转新页面打开-实现方式
      if (!_this.brandQueryValue) {
        this.$message({
          message: '内容不能为空',
          type: 'warning'
        })
        return false
      }
      this.$router.push({
        path: '/brand/list',
        query: { inputVal: inputVal }
      })
      // 跳转页面
      // let { href } = this.$router.resolve({
      //   path: '/brand/list',
      //   query: { inputVal: inputVal }
      // })
      // window.open(href, "_blank") // 跳转新页面打开-实现方式
      // window.location.href = href // 覆盖页面打开-实现方式
    },
    isLogin(val) {
      this.$axios({
        method: 'get',
        url: '/service/user/userinfo',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then((res) => {
          if (val == 1) {
            this.brandSearchHandle()
          } else if (val == 2) {
            this.$router.push('/brand/advansearch')
            // window.open('/brand/advansearch')
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            // 显示登录弹框
            let showLogin = this.$store.state.showLogin
            this.$store.commit('changeShowLogin', !showLogin)
          }
        })
    }
    // 以上是专利检索条件内容----------------------------------------------------------------------------------
  }
}
</script>

<style scoped>
/* 检索部分 */
.search-commonbox {
  text-align: left;
}
/* 单选框 */
.common-radiobox {
  margin: 20px 0 10px;
}
.common-radiobox .el-radio-button__inner {
  display: block;
  float: left;
  padding: 0 10px;
  height: 24px;
  line-height: 24px;
  border: none !important;
  border-radius: 0;
  box-sizing: border-box;
  color: #333333;
  cursor: pointer;
}
.common-radiobox .el-radio-button__inner:hover {
  color: #333333;
}
.common-radiobox .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: none;
  box-shadow: none;
  color: #333333;
  font-weight: 700;
}
/* 搜索框 */
.common-querybox {
  position: relative;
  margin-bottom: 10px;
  height: 40px;
}
.comquery-inputbox {
  position: relative;
  float: left;
  width: 1000px;
}
.inputbox-input {
  display: block;
}
.inputbox-input .el-input__inner {
  display: block;
  margin: 0;
  padding: 0 52px 0 10px;
  width: 1000px;
  height: 40px;
  line-height: 40px;
  border: 1px solid rgba(121, 121, 121, 1);
  border-radius: 0;
  background: #ffffff;
  outline: none;
  box-sizing: border-box;
  color: #333333;
  font-size: 14px;
}
.inputbox-input .el-input__inner:focus {
  border: 1px solid #050162;
}
.inputbox-btn {
  position: absolute;
  top: 1px;
  right: 0px;
}
.comquery-inputbox .el-button {
  padding: 0px 10px;
  height: 38px;
  line-height: 38px;
  border: none;
  background: none;
  border-radius: 0;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  box-sizing: border-box;
  outline: none;
  color: #d42a2a;
  font-weight: 700;
  font-size: 16px;
}
.common-querybox .comquery-advanced {
  position: absolute;
  top: 0;
  right: 0px;
  display: block;
  line-height: 42px;
  font-weight: 400;
  font-size: 12px;
  cursor: pointer;
}
/* 复选框 */
.common-comcheckbox {
  margin-bottom: 20px;
  padding-left: 5px;
  text-align: left;
  box-sizing: border-box;
  font-size: 12px;
}
.common-comcheckbox:after {
  display: block;
  content: '';
  clear: both;
}
.comcheckbox-group {
  display: block;
  float: left;
  margin: 0 10px 0 0;
}
.common-comcheckbox .el-checkbox {
  display: block;
  float: left;
  margin-right: 10px;
}
.comcheckbox-group .el-checkbox__label {
  padding-left: 6px;
  color: #333333 !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #d42a2a;
  border-color: #d42a2a;
}
/* 更新时间说明 */
.common-inforcon {
  margin-left: 5px;
}
.inforcon-inforp {
  color: #d42a2a;
  font-weight: 700;
  font-size: 12px;
}
/* 商标检索-输入框-申请人地址-弹框 */
.bretrieve-brsite {
  display: none;
  position: absolute;
  bottom: -6px;
  left: 50%;
  margin-left: -375px;
  width: 750px;
  height: 288px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(180, 180, 180, 0.4);
  box-sizing: border-box;
  z-index: 10;
}
.popup-brandaddress .el-dialog {
  width: 750px;
}
.popup-brandaddress .el-dialog .el-dialog__header {
  display: none;
}
.popup-brandaddress .el-dialog .el-dialog__body {
  padding: 0;
}
.brsite-brlocate {
  height: 230px;
  border-bottom: 1px solid #e8e8e8;
  box-sizing: border-box;
}
.brlocate-bchoose {
  float: left;
  padding: 25px 0 0 10px;
  width: 250px;
  height: 229px;
  box-sizing: border-box;
  overflow: hidden;
}
.bchoose-bcoption {
  display: block;
  float: left;
  margin: 0 3px 8px 0;
  padding: 3px 3px;
  cursor: pointer;
}
.bcprovince-bsid {
  display: none;
}
.bcprovince-bctxt {
  display: block;
}
.bchoose-bcoption:hover {
  background: #f44d4d;
  border-radius: 3px;
  color: #fff;
}
.bchoose-bcoption-atv {
  background: #f44d4d;
  border-radius: 3px;
  color: #fff;
}
.brlocate-bcenter {
  background: #eee;
}
.bpre-nohave {
  line-height: 180px;
  text-align: center;
  color: #a9a9a9;
}
.brsite-brelect {
  padding-left: 15px;
  height: 58px;
  box-sizing: border-box;
}
.brelect-bresult {
  display: block;
  float: left;
  margin-right: 10px;
  line-height: 58px;
  color: #f44d4d;
}
.brelect-bresinp {
  margin-top: 13px;
  /* padding-left: 15px; */
  padding: 0;
  width: 380px;
  height: 32px;
  /* border: 1px solid #3184d9; */
  box-sizing: border-box;
}
.brelect-bresinp .el-input__inner {
  height: 32px;
  line-height: 32px;
  border: 1px solid #3184d9;
  border-radius: 0;
}
.brelect-bresinp::-webkit-input-placeholder {
  color: #a9a9a9;
}
.brelect-bresinp:-moz-placeholder {
  color: #a9a9a9;
}
.brelect-bresinp::-moz-placeholder {
  color: #a9a9a9;
}
.brelect-bresinp:-ms-input-placeholder {
  color: #a9a9a9;
}
.brelect-bconfirm {
  display: block;
  float: right;
  margin: 13px 15px 0 0;
  padding: 0;
  width: 48px;
  height: 32px;
  background: #f44d4d;
  border-radius: 3px;
  outline: none;
  color: #ffffff;
}
.brelect-bconfirm:hover,
.brelect-bconfirm:focus {
  background: #f44d4d;
  color: #ffffff;
}
.brelect-bempty {
  display: block;
  float: right;
  margin: 13px 15px 0 0;
  padding: 0;
  width: 48px;
  height: 32px;
  border: none;
  outline: none;
  color: #3184d9;
}
.brelect-bempty:hover,
.brelect-bempty:focus {
  background: none;
  color: #3184d9;
}
.brand-mark {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 5;
}
.brand-tooltip {
  display: none;
  position: fixed;
  top: 380px;
  left: 50%;
  margin-left: -150px;
  padding: 15px 50px 15px;
  max-width: 300px;
  line-height: 22px;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  box-shadow: 0px 0px 5px #fff;
  color: #fff;
  font-size: 14px;
  z-index: 10;
}
</style>
